import React from "react";
import axios from "axios";
import { PrintButton } from "../../components/printButton";
import { t } from "../../localization/localization";

import { Pie } from "react-chartjs-2";
import "chartjs-plugin-datalabels";

export default class PubStudyCategoryDist extends React.Component {
  state = {
    data: [],
  };

  componentDidMount() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const crisId = urlSearchParams.get("crisId");
    axios
      .get(
        `${window._env_.BASE_URL}/gcris-api/researcher/${crisId}/pubStudyCategoryDist`
      )
      .then((res) => {
        this.setState({
          data: res.data.map((e) => {
            return { label: e.category, data: e.count };
          }),
        });
      });
  }

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";
    const paletteName = urlSearchParams.get("palette");
    return (
      <div style={{ width: 440, height: 320, margin: "auto" }}>
        <PrintButton />
        <Pie
          data={{
            labels: this.state.data.map((e) => e.label),
            datasets: [
              {
                data: this.state.data.map((e) => e.data),
                backgroundColor: generateColors(
                  this.state.data.length,
                  paletteName
                ),
                hoverBackgroundColor: generateColors(
                  this.state.data.length,
                  paletteName
                ),
              },
            ],
          }}
          width={440}
          height={320}
          options={{
            maintainAspectRatio: false,
            plugins: {
              datalabels: {
                display: true,
                color: "white",
              },
            },
          }}
        />
      </div>
    );
  }
}

const PALETTE = {
  cold: ["#003f5c", "#58508d", "#bc5090", "#ff6361", "#ffa600"],
};

function generateColors(count, paletteName) {
  var palette;
  if (!PALETTE[paletteName]) {
    palette = PALETTE["cold"];
  } else {
    palette = PALETTE[paletteName];
  }
  var colors = [];
  for (var i = 0; i < count; i++) {
    colors.push(palette[i % palette.length]);
  }
  return colors;
}
